var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMgf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.929,
    height: 30,
    transform: "translate(0 0)",
    fill: "#73a91b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-308 -827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,0C55,0,55,0,55,27.5S55,55,27.5,55,0,55,0,27.5,0,0,27.5,0Z",
    transform: "translate(308 827)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(489 848.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-177 -8.999)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.742,16.794a5.5,5.5,0,1,0-5.5-5.5,5.5,5.5,0,0,0,5.5,5.5",
    transform: "translate(-2.835 -2.267)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.821,33.951H5.233v6.024h5v-8.1a8.586,8.586,0,0,1,2.486-6.181,17.364,17.364,0,0,0-2.814-.222C4.658,25.472,0,27.645,0,32.461v7.515H3.6Z",
    transform: "translate(0 -9.976)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.814,11.292a5.5,5.5,0,1,0-5.5,5.5,5.5,5.5,0,0,0,5.5-5.5",
    transform: "translate(-20.288 -2.267)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.95,32.461c0-4.815-4.658-6.988-9.906-6.988a17.378,17.378,0,0,0-2.814.221,8.584,8.584,0,0,1,2.486,6.181v8.1h5.03V33.951h1.383l.218,6.024h3.6Z",
    transform: "translate(-22.021 -9.976)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.272,23.931a9.162,9.162,0,0,1,.176,1.8v2.115a3.5,3.5,0,0,1,3.168,3.208l0,3.262A1.385,1.385,0,0,1,40.3,35.4a1.172,1.172,0,0,1-.874.329.761.761,0,0,1-.334-1.444V31.059c0-.948-1.1-1.75-2.407-1.75s-2.407.8-2.407,1.75l0,3.236a.764.764,0,0,1,.423.679.754.754,0,0,1-.753.76,1.177,1.177,0,0,1-.877-.33,1.39,1.39,0,0,1-.316-1.084h0V31.059a3.5,3.5,0,0,1,3.168-3.208V25.736a7.57,7.57,0,0,0-.366-2.32c-.17-.04-.338-.082-.511-.117L31.176,28.05,27.306,23.3c-.294.06-.583.13-.868.205a7.517,7.517,0,0,0-.334,2.229v4.846a2,2,0,1,1-1.521,0V25.736a9.219,9.219,0,0,1,.15-1.653c-2.991,1.241-5.041,3.507-5.041,6.94v8.1h22.97v-8.1c0-3.591-2.21-5.894-5.389-7.092",
    transform: "translate(-7.712 -9.124)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.462,12.758a6.379,6.379,0,1,0-6.378-6.379,6.381,6.381,0,0,0,6.378,6.379",
    transform: "translate(-10.998 0)",
    fill: "#73a91b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMgf);
export default __webpack_public_path__ + "static/media/MGF.ed563b95b07045dd559c18126f4618c8.svg";
export { ForwardRef as ReactComponent };